import React, {Component, Fragment} from 'react'
import { withRouteData, Head } from 'react-static'

import Picture from '../../../components/Picture'
import ButtonLink from '../../../components/site/Button/ButtonLink'
import DemoRequestLink from '../../../components/site/DemoRequest/DemoRequestLink'

import Heading1 from '../../../components/site/typography/Heading1'
import Heading2 from '../../../components/site/typography/Heading3'
import Heading5 from '../../../components/site/typography/Heading5'
import Link from '../../../components/site/typography/Link'
import Menu from '../../../blocks/Menu/NewMenu'
import Paragraph from '../../../components/site/typography/Paragraph'
import TrialButton from '../../../components/site/TryIt/TrialButton'

import './MeusPedidos.scss'
import './MeusPedidosv2.scss'

class MeusPedidos extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let headData = this.props.headData

        return(
            <Fragment>
                {headData && <Head>
                    <title>{ headData.pageTitle }</title>
                    <meta property="og:title" content={ headData.pageTitle } />
                    <meta name="twitter:title" content={ headData.pageTitle } />
                    <meta name="description" content={ headData.pageDescription } />
                    <meta property="og:description" content={ headData.pageDescription } />
                    <meta name="twitter:description" content={ headData.pageDescription } />
                    <meta property="og:image" content={ headData.ogImage } />
                    <meta name="twitter:image" content={ headData.ogImage } />
                    <meta property="og:url" content={ headData.ogUrl } />
                </Head>}
                <Menu loginOnly mutableMenu regularLogo/>
                <div className='meus-pedidos-header meus-pedidos-new'>
                    <div className='container'>
                        <h1>Meus Pedidos agora é <strong>Mercos</strong></h1>
                        <h2>Levamos toda a praticidade do <strong>Meus Pedidos</strong> para o <strong>Mercos</strong> que, além de prático, é completo <br className='show-for-large'/>para gerenciar e potencializar vendas de indústrias, distribuidoras e representantes.</h2>
                        <ButtonLink className='new-button button-primary' href='https://mercos.com/'>
                            Acessar Mercos
                        </ButtonLink>
                        <span>
                            <Paragraph white>ou <Link
                                href='https://blog.mercos.com/meus-pedidos-agora-e-mercos/'
                                color='linkLight'
                                target='_blank'
                                title='Saiba mais detalhes sobre a mudança da Mercos.'
                                weight='bold'>
                                Leia sobre a mudança
                            </Link></Paragraph>
                        </span>
                        <Picture className='hero-image' src='/images/site/hero-meus-pedidos.png' alt='Mercos, o sistema para gerenciar e potencializar vendas de indústrias, distribuidoras e representantes.'/>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default withRouteData(props => <MeusPedidos {...props} />)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/MeusPedidosv2.jsx